<app-toolbar></app-toolbar>
<main>
<div class="page-inner main">
  <h1>{{ title$ | async | translate }}</h1>
  <div>{{ description$ | async | translate }}</div>
</div>
</main>
